import React from 'react';
import {
  Row,
  Col,
  FormGroup,
  Input,
  Label,
  FormFeedback,
  FormText,
} from 'reactstrap';
import Text from '../Text';

const renderHelpText = (text) => (text ? (<Col className="label-help"><FormText>{ text }</FormText></Col>) : null);

const buildInputClasses = ({ name, validationData }) => {
  const validationResult = validationData[name];
  if (validationResult && validationResult.isInvalid) return 'is-invalid';
  return '';
};

const buildType = (type) => type || 'text';

const buildValidationMessage = ({ name, validationData }) => {
  const validationResult = validationData[name];
  if (!validationResult) return null;
  return (validationResult.message || '');
};

export default function TextInputView(props) {
  return (
    <FormGroup>
      <Row>
        <Col sm="auto" className="label-main">
          <Label htmlFor={props.name}>
            <Text value={props.label} />
            { props.required ? '*' : null }
          </Label>
        </Col>
        { renderHelpText(props.helpText) }
      </Row>
      <Input
        className={buildInputClasses(props)}
        name={props.name}
        id={props.name}
        type={buildType(props.type)}
        pattern={props.pattern}
        maxLength={props.maxLength}
        value={props.formData[props.name]}
        onChange={props.onChange}
        onKeyPress={props.onKeyPress}
        disabled={props.disabled}
      />
      <FormFeedback>{ buildValidationMessage(props) }</FormFeedback>
    </FormGroup>
  );
}
